import { memo } from 'react';
import styled from 'styled-components';
import InlineAttachment from './InlineAttachment';
import { jsx as _jsx } from "react/jsx-runtime";
const FileAttachmentsWrapper = styled.div.attrs({
  'data-test-id': 'inline-attachments-wrapper'
}).withConfig({
  displayName: "InlineAttachments__FileAttachmentsWrapper",
  componentId: "jvuclp-0"
})(["cursor:pointer;box-sizing:border-box;width:100%;display:block;margin-bottom:16px;margin-top:8px;"]);
const InlineAttachments = ({
  fileAttachments,
  genericChannelId
}) => {
  return /*#__PURE__*/_jsx(FileAttachmentsWrapper, {
    children: fileAttachments.map((fileAttachment, index) => /*#__PURE__*/_jsx(InlineAttachment, {
      fileAttachment: fileAttachment,
      genericChannelId: genericChannelId
    }, `attachment-${index}`))
  });
};
InlineAttachments.displayName = 'InlineAttachments';
export default /*#__PURE__*/memo(InlineAttachments);